// extracted by mini-css-extract-plugin
export default {"box":"HealthStatus_box__c3Nd0","content":"HealthStatus_content__NMDw9"};